import api from './api';

export interface FtthAreaMapa {
  id: number;
  nome: string;
  coordenadas: Array<{ lat: number; lng: number }>;
  cor?: string | null;
  escritorio_id: number;
  usuarioId_criou: number;
  informacoes?: string | null;
  createdAt: string;
  updatedAt: string;
  usuario_criou?: { id: number; nome: string; usuario: string };
  escritorio?: { id: number; identificacao: string; nome_fantasia: string };
}

export interface FtthAreaMapaForMap {
  id: number;
  nome: string;
  coordenadas: Array<{ lat: number; lng: number }>;
  cor: string;
  escritorio_id: number;
  informacoes?: string | null;
}

class FtthAreaMapaService {
  async getAreas(params?: { escritorio_id?: number }) {
    const response = await api.get('/ftth-area-mapa', { params });
    return response.data;
  }

  async getAreasForMap(): Promise<FtthAreaMapaForMap[]> {
    const response = await api.get('/ftth-area-mapa/map');
    const arr = Array.isArray(response) ? response : (response?.data && Array.isArray(response.data) ? response.data : []);
    return arr.map((a: any) => {
      let coords = a.coordenadas;
      if (typeof coords === 'string') {
        try {
          coords = JSON.parse(coords);
        } catch {
          coords = [];
        }
      }
      const coordenadas = Array.isArray(coords) ? coords : [];
      return {
        id: a.id,
        nome: a.nome || '',
        coordenadas,
        cor: a.cor || '#2196F3',
        escritorio_id: a.escritorio_id,
        informacoes: a.informacoes || null
      };
    });
  }

  async getArea(id: number) {
    const response = await api.get(`/ftth-area-mapa/${id}`);
    return response.data?.data ?? response.data;
  }

  async create(data: {
    nome: string;
    coordenadas: Array<{ lat: number; lng: number }>;
    cor?: string;
    escritorio_id: number;
    informacoes?: string | null;
  }) {
    const response = await api.post('/ftth-area-mapa', data);
    return response.data?.data ?? response.data;
  }

  async update(
    id: number,
    data: Partial<{
      nome: string;
      coordenadas: Array<{ lat: number; lng: number }>;
      cor: string;
      escritorio_id: number;
      informacoes: string | null;
    }>
  ) {
    const response = await api.put(`/ftth-area-mapa/${id}`, data);
    return response.data?.data ?? response.data;
  }

  async delete(id: number) {
    await api.delete(`/ftth-area-mapa/${id}`);
  }
}

export const ftthAreaMapaService = new FtthAreaMapaService();
